import BaseController from './baseSystemController';
import eControllerTypes from './bugReport/eControllerTypes';
import ControllerReportForm from './bugReport/ControllerReportForm';
import SubmitSuccess from '../common/submitSuccess';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../utils/constants';

export default class ControllerBugReport extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_CLOSE: 'close_button',
    };
    this._eEventTypes = {
      CLOSE_CLICK: this.getEventName(this._eButtonsTypes.EBT_CLOSE),
    };
    this._eControllersClasses = {
      [this.controllerTypes.EBRCT_FORM]: ControllerReportForm,
      [this.controllerTypes.EBRCT_SUBMIT_SUCCESS]: SubmitSuccess,
    }
    this._eElementsTypes = {
      EET_OVERLAY: 'overlay',
      EET_MODAL_CONTAINER: 'modal_container',
      EET_TITLE: 'title',
      EET_CLOSE_BUTTON: this._eButtonsTypes.EBT_CLOSE,
      EET_CONTAINER_FORM: this.controllerTypes.EBRCT_FORM,
      EET_CONTAINER_SUBMIT_SUCCESS: this.controllerTypes.EBRCT_SUBMIT_SUCCESS,
    };

    this._eButtonsActions = {
      [this._eButtonsTypes.EBT_CLOSE]: this.hide.bind(this),
    };

    this._localizations = {
      [this._eElementsTypes.EET_TITLE]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.bugReport.title`,
    }

    this._isSpinBlocker = true;

    this.init(container);
    this.hide();
  }

  show() {
    super.show();
    const controllerForm = this.controllers[this.controllerTypes.EBRCT_FORM];
    const controllerSubmitSuccess = this.controllers[this.controllerTypes.EBRCT_SUBMIT_SUCCESS];
    controllerForm.show();
    controllerSubmitSuccess.hide();
  }

  cleanup() {
    super.cleanup();
    this._abortRequest && this._abortRequest();
  }

  _afterInit() {
    super._afterInit();
    this._overlay = this.interactiveElements[this._eElementsTypes.EET_OVERLAY];
    this._modalContaier = this.interactiveElements[this._eElementsTypes.EET_MODAL_CONTAINER];
    this._overlay.onclick = (e) => {
      if (e.target === this._overlay) this.hide();
    };

    const controllerSubmitSuccess = this.controllers[this.controllerTypes.EBRCT_SUBMIT_SUCCESS];
    controllerSubmitSuccess.localizations = {
      [controllerSubmitSuccess.elementsTypes.EET_TITLE]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.bugReport.submitSuccess.title`,
      [controllerSubmitSuccess.elementsTypes.EET_TEXT]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.bugReport.submitSuccess.description`,
      [controllerSubmitSuccess.elementsTypes.EET_BUTTON_TEXT]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.bugReport.submitSuccess.buttonBackToMenu`,
    }
  }

  _addExtraControllersListeners() {
    super._addExtraControllersListeners();
    const controllerForm = this.controllers[this.controllerTypes.EBRCT_FORM];
    const controllerSubmitSuccess = this.controllers[this.controllerTypes.EBRCT_SUBMIT_SUCCESS];

    controllerForm.on(controllerForm.events[this.controllerTypes.EBRCT_FORM].SUBMIT, async (data) => {
      console.log(data);
      const { abortRequest, promise } = window.OPWrapperService.serverManager.createBugReport(data);
      this._abortRequest = abortRequest;
      const success = await promise;
      this.controllers[this.controllerTypes.EBRCT_FORM].loading = false;

      if (success) {
        controllerForm.hide();
        controllerSubmitSuccess.show();
      }
    });

    controllerSubmitSuccess.on(controllerSubmitSuccess.events[this.controllerTypes.EBRCT_SUBMIT_SUCCESS].OK_CLICK, () => {
      this.hide();
    })
  }

  get controllerTypes() {
    return eControllerTypes;
  }

  set scaleData({ scaleData, rootScale }) {
    if (!this._mounted) return;
    this._scaleData = scaleData;

    this._modalContaier.dataset.orientation = scaleData.isPortrait ? 'portrait' : 'landscape';
    this._modalContaier.dataset.deviceType = scaleData.isMobile ? 'mobile' : 'desktop';

    for (const key in this.controllers) {
      const controller = this.controllers[key];
      controller.scaleData = { scaleData: this._scaleData };
    }
  }

  _getMarkup() {
    return `<div id=${this.interactiveElementsIds[this._eElementsTypes.EET_OVERLAY]} class="system-ui-container__modal_wrapper system-ui-container__modal__bug_report">
      <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_MODAL_CONTAINER]} class="system-ui-container__modal_container system-ui-container__modal__bug_report__container">
        <div class="system-ui-container__modal_container__header">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TITLE]}>
                  ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TITLE])}
          </span>
          <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_CLOSE_BUTTON]} class="system-ui-container__close_button system-ui-container__modal_container__header__close">
            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M66 22L22 66M22 22L66 66" stroke="white" stroke-width="6.28571" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div class="system-ui-container__modal__bug_report__container_form" id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_FORM]}>
        </div>
        <div class="system-ui-container__modal__bug_report__container_success" id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_SUBMIT_SUCCESS]}>
        </div>
      </div>
    </div>`
  }
}
